import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import { COLORS } from 'config'
import Avatar from 'components/profile/Avatar'
import PersonInfo from 'components/profile/PersonInfo'
import SendMessageButton from 'components/common/SendMessageButton'
import Icon, { ICON_X_LIGHT } from 'components/common/Icon'
import Button from 'components/common/Button'

class MatchItem extends React.Component {
  state = {
    disabled: false
  }

  handleDeleteClick = () => {
    this.setState({ disabled: true })
    this.props.onDeleteMatch()
  }

  render() {
    const {
      onSendMessage,
      onMatchClick,
      profilePic,
      firstName,
      age,
      distance
    } = this.props

    return (
      <Div
        flex={1}
        position="relative"
        display="flex"
        paddingLeft={15}
        paddingRight={15}
        flexDirection="row"
        alignItems="center"
        opacity={this.state.disabled ? 0.25 : 1}
        transition="opacity 70ms"
      >
        <div onClick={onMatchClick}>
          <Avatar src={profilePic} />
        </div>
        <Div marginLeft={15}>
          <PersonInfo
            profilePic={profilePic}
            firstName={firstName}
            age={age}
            distance={distance}
          />
          <Div height={4} />
          <SendMessageButton text="Send Message" onClick={onSendMessage} />
          <Div position="absolute" top={6} right={3}>
            <Button onClick={this.handleDeleteClick}>
              <Icon path={ICON_X_LIGHT} width={24} height={24} color={COLORS.grey} />
            </Button>
          </Div>
        </Div>
      </Div>
    )
  }
}

MatchItem.propTypes = {
  onSendMessage: PropTypes.func,
  onMatchClick: PropTypes.func,
  onDeleteMatch: PropTypes.func,
  profilePic: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  age: PropTypes.number.isRequired,
  distance: PropTypes.string
}

MatchItem.defaultProps = {
  onSendMessage: () => {},
  onMatchClick: () => {},
  onDeleteMatch: () => {}
}

export default MatchItem



// WEBPACK FOOTER //
// ./src/components/matches/MatchItem.js